// extracted by mini-css-extract-plugin
export var desktopWidgetWrapper = "Desktop-module--desktopWidgetWrapper--2G3Qv";
export var container = "Desktop-module--container--yuD09";
export var heading = "Desktop-module--heading--28Ttt";
export var modalWrapper = "Desktop-module--modalWrapper--3xecS";
export var modalContent = "Desktop-module--modalContent--VYshp";